import api from '../utils/api';
import { convertFormDates } from '../utils/dates';

export default {
  get(uuid) {
    return api.get(`/goats/${uuid}/`);
  },

  create(values) {
    return api.post('/goats/', convertFormDates(values, ['birthDate','deathDate','dateMating','borkedDate','date']));
  },

  edit(uuid, values) {
    return api.patch(`/goats/${uuid}/`, convertFormDates(values, ['birthDate','deathDate','dateMating','borkedDate','date']));

  },

  remove(uuid) {
    return api.delete(`/goats/${uuid}/`);
  },

  // Фильтр parent отбирает коз, у которых uuid указан в mother_goat / father_goat.
  // Пока бэкенд без этого фильтра, параметр игнорируется и придёт весь список,
  // поэтому результат дополнительно фильтруем на клиенте
  async getOffspring(uuid) {
    const offspring = [];
    let page = 1;
    let hasNext = true;

    while (hasNext) {
      const { data } = await api.get('/goats/', {
        params: { parent: uuid, page, page_size: 100 },
      });

      data.results
        .filter((item) => item.motherGoat === uuid || item.fatherGoat === uuid)
        .forEach(({ id, name, tag, motherGoat, fatherGoat }) =>
          offspring.push({ id, name, tag, motherGoat, fatherGoat }),
        );

      hasNext = !!data.next;
      page += 1;
    }

    return offspring;
  },
};
